module.exports = __webpack_public_path__ + "img/HighlyRestrictedEarlyWeightBearingAndExercise.1c3eccf9.jpg";